import { Action } from '@ngrx/store';
import { ContractInfo } from 'app/core/store/contract-info/contract-info.interface';
import { CustomerInfo } from 'app/core/store/customer-info/customer-info.interface';
import { Definition } from 'app/core/store/definitions/definition.interface';
import { Definitions } from 'app/core/store/definitions/definitions.interface';
import { Customer } from 'app/core/store/session/user-context/user-context.interface';
import { FlowDetailTO, Material, PackingMaterial } from '../edit-florder-detail/florder-detail.interface';
import { Florder } from '../../interfaces/florder.interface';
import { DatesRange } from '../../util/date.utils';

export const FLOWDETAIL_OPEN = 'flowDetail:FLOWDETAIL_OPEN';
export const FLOWDETAIL_OPEN_SUCCESS = 'flowDetail:FLOWDETAIL_OPEN_SUCCESS';
export const FLOWDETAIL_OPEN_FAIL = 'flowDetail:FLOWDETAIL_OPEN_FAIL';
export const FLOWDETAIL_CREATE_START = 'flowDetail:FLOWDETAIL_CREATE_START'; // Start create-window
export const FLOWDETAIL_CREATE_SET_CUSTOMER = 'flowDetail:CREATE_STEP_0_SET_CUSTOMER';
export const FLOWDETAIL_CREATE_SET_DELIVERY_METHOD = 'flowDetail:FLOW_CREATE_STEP_1_SET_DELIVERY_METHOD'; // Store deliveryMethod data in store, and go to details window in edit mode
export const FLOWDETAIL_CREATE_EDIT_FLOW_DETAIL = 'flowDetail:FLOWDETAIL_CREATE_EDIT_FLOW_DETAIL'; // Start adding a new material (used when editing details again)
export const FLOWDETAIL_CREATE_EDIT_FLOW_PLANNING = 'flowDetail:FLOWDETAIL_CREATE_EDIT_FLOW_PLANNING';
export const FLOWDETAIL_CREATE_START_EDIT_MATERIAL = 'flowDetail:FLOWDETAIL_CREATE_START_EDIT_MATERIAL'; // Start editing an existing material
export const FLOWDETAIL_CREATE_SAVE_MATERIAL = 'flowDetail:FLOWDETAIL_CREATE_SAVE_MATERIAL'; // Save material in store
export const FLOWDETAIL_CREATE_DELETE_MATERIAL = 'flowDetail:FLOWDETAIL_CREATE_DELETE_MATERIAL'; // Delete material from store
export const FLOWDETAIL_CREATE_SAVE_FLOW_DETAIL = 'flowDetail:FLOWDETAIL_CREATE_SAVE_FLOW_DETAIL'; // Save flow detail data in store
export const FLOWDETAIL_CREATE_SAVE_FLOW_DETAIL_GET_DATES_SUCCESS = 'flowDetail:FLOWDETAIL_CREATE_SAVE_FLOW_DETAIL_GET_DATES_SUCCESS'; // Save flow detail data in store
export const FLOWDETAIL_CREATE_SAVE_PLANNING = 'flowDetail:FLOWDETAIL_CREATE_SAVE_PLANNING';
export const FLOWDETAIL_CREATE_OR_UPDATE_SUBMIT = 'flowDetail:FLOWDETAIL_CREATE_OR_UPDATE_SUBMIT'; // Submit 'create flow' data to middleware
export const FLOWDETAIL_CREATE_OR_UPDATE_SUBMIT_FAIL = 'flowDetail:FLOWDETAIL_CREATE_OR_UPDATE_SUBMIT_FAIL'; // Submit failed
export const FLOWDETAIL_CREATE_OR_UPDATE_SUBMIT_SUCCESS = 'flowDetail:FLOWDETAIL_CREATE_OR_UPDATE_SUBMIT_SUCCESS'; // Submit successful
export const FLOWDETAIL_EDIT_DELIVERY_METHOD = 'flowDetail:FLOWDETAIL_EDIT_DELIVERY_METHOD';
export const FLOWDETAIL_COPY_FLOW = 'flowDetail:FLOWDETAIL_COPY_FLOW'; // copy flow
export const FLOWDETAIL_COPY_OPEN_FLOW_SUCCESS = 'flowDetail:FLOWDETAIL_COPY_OPEN_FLOW_SUCCESS'; // copy flow open flow success
export const FLOWDETAIL_COPY_OPEN_FLOW_FAIL = 'flowDetail:FLOWDETAIL_COPY_OPEN_FLOW_FAIL'; // copy flow open flow success
export const FLOWDETAIL_COPY_OPEN_FLOW_NO_VALID_CONTRACT = 'flowDetail:FLOWDETAIL_COPY_OPEN_FLOW_NO_VALID_CONTRACT'; // copy flow open flow success but no valid contract
export const FLOWDETAIL_RESET_MATERIALS_AND_PLANNING = 'flowDetail:FLOWDETAIL_RESET_MATERIALS_AND_PLANNING';

export const FLOWDETAIL_ACCEPT_FLOW_START = 'flowDetail:FLOWDETAIL_ACCEPT_FLOW_START'; // copy flow open flow success but no valid contract
export const FLOWDETAIL_ACCEPT_FLOW_SUCCESS = 'flowDetail:FLOWDETAIL_ACCEPT_FLOW_SUCCESS'; // copy flow open flow success but no valid contract
export const FLOWDETAIL_ACCEPT_FLOW_FAIL = 'flowDetail:FLOWDETAIL_ACCEPT_FLOW_FAIL'; // copy flow open flow success but no valid contract

export const FLOWDETAIL_REQUEST_DELIVERY_DATES = 'flowDetail:FLOWDETAIL_REQUEST_DELIVERY_DATES';
export const FLOWDETAIL_REQUEST_DELIVERY_DATES_SUCCESS = 'flowDetail:FLOWDETAIL_REQUEST_DELIVERY_DATE_SUCCESS';
export const FLOWDETAIL_REQUEST_DELIVERY_DATES_FAIL = 'flowDetail:FLOWDETAIL_REQUEST_DELIVERY_DATES_FAIL';

export const FLOWDETAIL_BACK_TO_DELIVERY = 'flowDetail:FLOWDETAIL_BACK_TO_DELIVERY';
export const FLOWDETAIL_BACK_TO_DETAIL = 'flowDetail:FLOWDETAIL_BACK_TO_DETAIL';

export const FLOWDETAIL_EDIT_DISPUTE = 'flowDetail:FLOWDETAIL_EDIT_DISPUTE'; // edit dispute
export const FLOWDETAIL_EDIT_FLOW = 'flowDetail:FLOWDETAIL_EDIT_FLOW'; // edit flow
export const FLOWDETAIL_EDIT_ACCEPT_FLOW = 'flowDetail:FLOWDETAIL_EDIT_ACCEPT_FLOW'; // edit accept flow

export const FLOWDETAIL_DOCUMENT_DOWNLOAD = 'flowDetail:FLOWDETAIL_DOCUMENT_DOWNLOAD';
export const FLOWDETAIL_DOCUMENT_DOWNLOAD_FAIL = 'flowDetail:FLOWDETAIL_DOCUMENT_DOWNLOAD_FAIL';
export const FLOWDETAIL_DOCUMENT_DOWNLOAD_SUCCESS = 'flowDetail:FLOWDETAIL_DOCUMENT_DOWNLOAD_SUCCESS';

export const FLOWDETAIL_CHECK_FLOW_DATE = 'flowDetail:FLOWDETAIL_CHECK_FLOW_DATE';
export const FLOWDETAIL_CHECK_FLOW_DATE_SUCCESS = 'flowDetail:FLOWDETAIL_CHECK_FLOW_DATE_SUCCESS';
export const FLOWDETAIL_CHECK_FLOW_DATE_ERROR = 'flowDetail:FLOWDETAIL_CHECK_FLOW_DATE_ERROR';

export const FLOWDETAIL_SORT_MATERIALS = 'flowDetail:FLOWDETAIL_SORT_MATERIALS';

export class FlowDetailOpenAction implements Action {
  readonly type = FLOWDETAIL_OPEN;
  logPayload = true;

  ui = {
    id: FLOWDETAIL_OPEN,
    busy: true,
  };

  constructor(readonly payload: { etmOrderNumber: string; salesOrderNumber: string }) {}
}

export class FlowDetailOpenSuccessAction implements Action {
  readonly type = FLOWDETAIL_OPEN_SUCCESS;

  ui = {
    id: FLOWDETAIL_OPEN,
    busy: false,
  };

  constructor(readonly payload: { flowDetail: FlowDetailTO; customerInfo: CustomerInfo; contractInfo: ContractInfo; definitions: Definitions; customer: Customer }) {}
}

export class FlowDetailOpenFailAction implements Action {
  readonly type = FLOWDETAIL_OPEN_FAIL;
  logPayload = true;

  ui = {
    id: FLOWDETAIL_OPEN,
    busy: false,
  };

  constructor(readonly payload: any) {}
}

export class FlowDetailCreateStartAction implements Action {
  readonly type = FLOWDETAIL_CREATE_START;
  readonly module = 'flow';
  logPayload = true;

  constructor(readonly payload: { selectedCustomer: Definition; isSuperUser: boolean }) {}
}

export class FlowDetailCreateSetCustomerAction implements Action {
  readonly type = FLOWDETAIL_CREATE_SET_CUSTOMER;
  readonly module = 'flow';
  logPayload = true;

  constructor(readonly payload: { customer: Customer }) {}
}

export class FlowDetailCreateSetDeliveryMethodAction implements Action {
  readonly type = FLOWDETAIL_CREATE_SET_DELIVERY_METHOD;
  readonly module = 'flow';

  constructor(readonly payload: any) {}
}

export class FlowDetailCreateEditFlowDetailAction implements Action {
  readonly type = FLOWDETAIL_CREATE_EDIT_FLOW_DETAIL;
}

export class FlowDetailCreateEditFlowPlanningAction implements Action {
  readonly type = FLOWDETAIL_CREATE_EDIT_FLOW_PLANNING;
}

export class FlowDetailCreateStartEditMaterialAction implements Action {
  readonly type = FLOWDETAIL_CREATE_START_EDIT_MATERIAL;

  constructor(readonly payload: { material: Material }) {}
}

export class FlowDetailCreateSaveMaterialAction implements Action {
  readonly type = FLOWDETAIL_CREATE_SAVE_MATERIAL;

  constructor(readonly payload: { material: PackingMaterial; isDispute: boolean, definitions: Definitions }) {}
}

export class FlowDetailCreateRemoveMaterialAction implements Action {
  readonly type = FLOWDETAIL_CREATE_DELETE_MATERIAL;

  constructor(readonly payload: any) {}
}

export class FlowDetailEditDeliveryMethodAction implements Action {
  readonly type = FLOWDETAIL_EDIT_DELIVERY_METHOD;
}

export class FlowDetailSaveFlowDetailAction implements Action {
  readonly type = FLOWDETAIL_CREATE_SAVE_FLOW_DETAIL;
}

export class FlowDetailSaveFlowDetailGetDatesSuccessAction implements Action {
  readonly type = FLOWDETAIL_CREATE_SAVE_FLOW_DETAIL_GET_DATES_SUCCESS;
}

export class FlowDetailSavePlanningAction implements Action {
  readonly type = FLOWDETAIL_CREATE_SAVE_PLANNING;

  constructor(readonly payload: any) {}
}

export class FlowDetailCreateOrUpdateSubmitAction implements Action {
  readonly type = FLOWDETAIL_CREATE_OR_UPDATE_SUBMIT;

  constructor(readonly payload: { flowDetailForm: any }) {}
}

export class FlowDetailCreateOrUpdateSubmitFailAction implements Action {
  readonly type = FLOWDETAIL_CREATE_OR_UPDATE_SUBMIT_FAIL;
  logPayload = true;

  constructor(readonly payload?: any) {}
}

export class FlowDetailCreateOrUpdateSubmitSuccessAction implements Action {
  readonly type = FLOWDETAIL_CREATE_OR_UPDATE_SUBMIT_SUCCESS;

  constructor(readonly payload?: any) {}
}

export class FlowDetailGoBackToDeliveryAction implements Action {
  readonly type = FLOWDETAIL_BACK_TO_DELIVERY;

  constructor(readonly payload: string) {
    // payload = module (flow)
  }
}

export class FlowDetailGoBackToDetailAction implements Action {
  readonly type = FLOWDETAIL_BACK_TO_DETAIL;

  constructor(readonly payload: string) {
    // payload = module (flow)
  }
}

export class FlowDetailRequestDeliveryDatesAction implements Action {
  readonly type = FLOWDETAIL_REQUEST_DELIVERY_DATES;
  logPayload = true;

  ui = {
    id: FLOWDETAIL_REQUEST_DELIVERY_DATES,
    busy: true,
  };

  constructor(readonly payload?: Actions) {} // Which action to trigger when success
}

export class FlowDetailRequestDeliveryDatesSuccessAction implements Action {
  readonly type = FLOWDETAIL_REQUEST_DELIVERY_DATES_SUCCESS;
  logPayload = true;

  ui = {
    id: FLOWDETAIL_REQUEST_DELIVERY_DATES,
    busy: false,
  };

  constructor(readonly payload: DatesRange) {}
}

export class FlowDetailRequestDeliveryDatesFailAction implements Action {
  readonly type = FLOWDETAIL_REQUEST_DELIVERY_DATES_FAIL;
  logPayload = true;

  ui = {
    id: FLOWDETAIL_REQUEST_DELIVERY_DATES,
    busy: false,
  };

  constructor(readonly payload: any) {}
}

export class FlowDetailCopyFlowAction implements Action {
  readonly type = FLOWDETAIL_COPY_FLOW;
  logPayload = true;

  ui = {
    id: FLOWDETAIL_COPY_FLOW,
    busy: true,
  };

  constructor(readonly payload: { etmOrderNumber: string }) {} // id
}

export class FlowDetailCopyOpenSuccessAction implements Action {
  readonly type = FLOWDETAIL_COPY_OPEN_FLOW_SUCCESS;

  ui = {
    id: FLOWDETAIL_COPY_FLOW,
    busy: false,
  };

  constructor(readonly payload: { flowDetail: FlowDetailTO; customerInfo: CustomerInfo; contractInfo: ContractInfo; definitions: Definitions; customer: Customer }) {}
}

export class FlowDetailCopyOpenFailAction implements Action {
  readonly type = FLOWDETAIL_COPY_OPEN_FLOW_FAIL;
  logPayload = true;

  ui = {
    id: FLOWDETAIL_COPY_FLOW,
    busy: false,
  };

  constructor(readonly payload: any) {}
}

export class FlowDetailCopyOpenNoValidContractAction implements Action {
  readonly type = FLOWDETAIL_COPY_OPEN_FLOW_NO_VALID_CONTRACT;

  ui = {
    id: FLOWDETAIL_COPY_FLOW,
    busy: false,
  };
}

export class FlowAcceptFlowStartAction implements Action {
  readonly type = FLOWDETAIL_ACCEPT_FLOW_START;

  ui = {
    id: FLOWDETAIL_ACCEPT_FLOW_START,
    busy: true,
  };
}

export class FlowAcceptFlowSuccessAction implements Action {
  readonly type = FLOWDETAIL_ACCEPT_FLOW_SUCCESS;

  ui = {
    id: FLOWDETAIL_ACCEPT_FLOW_START,
    busy: false,
  };

  // TODO refactor using /flows/refresh
  constructor(readonly payload: { flow: Florder }) {}
}

export class FlowAcceptFlowFailAction implements Action {
  readonly type = FLOWDETAIL_ACCEPT_FLOW_FAIL;
  logPayload = true;

  ui = {
    id: FLOWDETAIL_ACCEPT_FLOW_START,
    busy: false,
  };

  constructor(readonly payload: any) {}
}

export class FlowDetailEditFlowAction implements Action {
  readonly type = FLOWDETAIL_EDIT_FLOW;

  constructor(readonly payload: { flowDetail: FlowDetailTO; customerInfo: CustomerInfo; contractInfo: ContractInfo; definitions: Definitions; customer: Customer }) {}
}

export class FlowDetailEditDisputeAction implements Action {
  readonly type = FLOWDETAIL_EDIT_DISPUTE;

  constructor(readonly payload: { flowDetail: FlowDetailTO; customerInfo: CustomerInfo; contractInfo: ContractInfo; definitions: Definitions; customer: Customer }) {}
}

export class FlowDetailEditAcceptFlowAction implements Action {
  readonly type = FLOWDETAIL_EDIT_ACCEPT_FLOW;

  constructor(readonly payload: { flowDetail: FlowDetailTO; customerInfo: CustomerInfo; contractInfo: ContractInfo; definitions: Definitions; customer: Customer }) {}
}

export class FlowDetailDocumentDownloadAction implements Action {
  readonly type = FLOWDETAIL_DOCUMENT_DOWNLOAD;
  logPayload = true;

  constructor(readonly payload: { etmOrderNumber: string; extension: string; customerIds: string[] }) {}
}

export class FlowDetailDocumentDownloadSuccessAction implements Action {
  readonly type = FLOWDETAIL_DOCUMENT_DOWNLOAD_SUCCESS;

  constructor(readonly payload: { blob: Blob; filename: string }) {}
}

export class FlowDetailDocumentDownloadFailAction implements Action {
  readonly type = FLOWDETAIL_DOCUMENT_DOWNLOAD_FAIL;
  logPayload = true;

  constructor(readonly payload: any) {}
}

export class FlowDetailCheckFlowDateAction implements Action {
  readonly type = FLOWDETAIL_CHECK_FLOW_DATE;
  logPayload = true;

  ui = {
    id: FLOWDETAIL_CHECK_FLOW_DATE,
    busy: true,
  };

  constructor(readonly payload: any) {}
}

export class FlowDetailCheckFlowDateSuccessAction implements Action {
  readonly type = FLOWDETAIL_CHECK_FLOW_DATE_SUCCESS;
  logPayload = true;

  ui = {
    id: FLOWDETAIL_CHECK_FLOW_DATE,
    busy: false,
  };

  constructor(readonly payload: any) {}
}

export class FlowDetailCheckFlowDateErrorAction implements Action {
  readonly type = FLOWDETAIL_CHECK_FLOW_DATE_ERROR;
  logPayload = true;

  ui = {
    id: FLOWDETAIL_CHECK_FLOW_DATE,
    busy: false,
  };

  constructor(readonly payload: any) {}
}

export class FlowDetailResetMaterialsAndPlanningAction implements Action {
  readonly type = FLOWDETAIL_RESET_MATERIALS_AND_PLANNING;
}

export class FlowDetailSortMaterialsAction implements Action {
  readonly type = FLOWDETAIL_SORT_MATERIALS;
  logPayload = ['sortField', 'sortAscending'];

  constructor(readonly payload: { sortField: string, sortAscending: boolean, definitions: Definitions }) {
  }
}

export type Actions =
  | FlowDetailCreateStartAction
  | FlowDetailCreateSetCustomerAction
  | FlowDetailCreateSetDeliveryMethodAction
  | FlowDetailEditDeliveryMethodAction
  | FlowDetailCreateEditFlowDetailAction
  | FlowDetailCreateStartEditMaterialAction
  | FlowDetailCreateSaveMaterialAction
  | FlowDetailCreateRemoveMaterialAction
  | FlowDetailSaveFlowDetailAction
  | FlowDetailSaveFlowDetailGetDatesSuccessAction
  | FlowDetailSavePlanningAction
  | FlowDetailCreateOrUpdateSubmitAction
  | FlowDetailCreateOrUpdateSubmitFailAction
  | FlowDetailCreateOrUpdateSubmitSuccessAction
  | FlowDetailOpenAction
  | FlowDetailOpenFailAction
  | FlowDetailOpenSuccessAction
  | FlowDetailCreateEditFlowPlanningAction
  | FlowDetailGoBackToDeliveryAction
  | FlowDetailGoBackToDetailAction
  | FlowDetailRequestDeliveryDatesAction
  | FlowDetailRequestDeliveryDatesSuccessAction
  | FlowDetailRequestDeliveryDatesFailAction
  | FlowDetailCopyFlowAction
  | FlowDetailCopyOpenSuccessAction
  | FlowDetailCopyOpenFailAction
  | FlowDetailCopyOpenNoValidContractAction
  | FlowDetailEditFlowAction
  | FlowDetailEditAcceptFlowAction
  | FlowDetailEditDisputeAction
  | FlowDetailDocumentDownloadAction
  | FlowDetailDocumentDownloadSuccessAction
  | FlowDetailDocumentDownloadFailAction
  | FlowAcceptFlowStartAction
  | FlowAcceptFlowSuccessAction
  | FlowAcceptFlowFailAction
  | FlowDetailCheckFlowDateAction
  | FlowDetailCheckFlowDateSuccessAction
  | FlowDetailCheckFlowDateErrorAction
  | FlowDetailResetMaterialsAndPlanningAction
  | FlowDetailSortMaterialsAction;
